import { Injectable } from '@angular/core';
import { IFormElementTypes } from './iform-element-types.service';
import { ValueTypeEnum } from '../model/value-type-enum.model';
import { FormElementType } from '../model/form-element-type.model';
import { ApiService, ApiCacheOptions, PagedSearch, PagedResult } from '../../../shared/index'; //app/shared/index barrel;

@Injectable()
export class FormElementTypes implements IFormElementTypes {
  private _availbleFormElementTypes: Array<FormElementType> = new Array<FormElementType>();
  private _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  public getFormElementType = (Id: number): Promise<FormElementType> => {
    let url: string = '/Forms/ElementType/' + Id.toString();
    return this._apiService.get(url, this._cacheOptions);
  };

  public getFormElementTypes = (): Promise<Array<FormElementType>> => {
    if (this._availbleFormElementTypes.length == 0) {
      let url: string = '/Forms/ElementTypes';
      return this._apiService.get(url, this._cacheOptions).then((data: Array<FormElementType>) => {
        this._availbleFormElementTypes = data;
        return Promise.resolve(this._availbleFormElementTypes);
      });
    } else {
      return Promise.resolve(this._availbleFormElementTypes);
    }
  };

  public getFormElementTypeTextbox = (): Promise<FormElementType> => {
    return this.getFormElementTypes().then((data: Array<FormElementType>) => {
      let element: FormElementType = data.find(x => x.Id == 1);
      return Promise.resolve(element);
    });
  };

  public getFormElementTypeCheckbox = (): Promise<FormElementType> => {
    return this.getFormElementTypes().then((data: Array<FormElementType>) => {
      let element: FormElementType = data.find(x => x.Id == 2);
      return Promise.resolve(element);
    });
  };

  public getFormElementTypeDropdownlistStringValue = (): Promise<FormElementType> => {
    return this.getFormElementTypes().then((data: Array<FormElementType>) => {
      let element: FormElementType = data.find(x => x.Id == 3);
      return Promise.resolve(element);
    });
  };

  public getFormElementTypeDropdownlistIntegerValue = (): Promise<FormElementType> => {
    return this.getFormElementTypes().then((data: Array<FormElementType>) => {
      let element: FormElementType = data.find(x => x.Id == 4);
      return Promise.resolve(element);
    });
  };

  private getFormElementTypeDropdownlist = (valueType: ValueTypeEnum, id: number): FormElementType => {
    let displayName = '';
    if (valueType == ValueTypeEnum.string) {
      displayName = 'Dropdownlist (string value)';
    }
    if (valueType == ValueTypeEnum.int) {
      displayName = 'Dropdownlist (integer value)';
    }
    if (valueType == ValueTypeEnum.decimal) {
      displayName = 'Dropdownlist (decimal value)';
    }
    return <FormElementType>{ Id: id, Name: 'dropdownlist', ValueType: valueType, DisplayName: displayName };
  };
}
